import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  ProcessCreditGrantOrderPayload,
  ProcessCreditGrantOrderResponse,
  processCreditGrantOrder,
} from '~/services/PromoService';

export function useProcessCreditGrantOrder() {
  const queryClient = useQueryClient();
  return useMutation<ProcessCreditGrantOrderResponse, Error, ProcessCreditGrantOrderPayload>({
    mutationFn: async (payload) => processCreditGrantOrder(payload),
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        queryClient.invalidateQueries({ queryKey: ['voucher-logs'] });
      }
    },
  });
}
